import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { API_PAGE_SIZE } from '../../core/constants';
import { AddressesApi } from '../api/addresses.api';
import { ApiError } from '../api/api-error';
import { mapAddress, mapAddresses, toAddressPayload } from '../mappers/address.mapper';
import type { Address, AddressDraft } from '../models/address/address.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

const ADDRESS_PATH = '/api/users/client/address';

@Injectable()
export class AddressesHttpApi extends AddressesApi {
  private readonly http = inject(HttpClient);

  override list(): Observable<Address[]> {
    // Сортировку не задаём: сервер и так отдаёт новые первыми, а страница вмещает весь лимит адресов.
    const params = new HttpParams().set('page', 0).set('size', API_PAGE_SIZE);
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath(ADDRESS_PATH), { params })
      .pipe(unwrapEnvelope<unknown>(), map(mapAddresses), mapApiError());
  }

  override create(draft: AddressDraft): Observable<Address> {
    return this.http
      .post<ApiEnvelope<unknown> | null>(apiPath(ADDRESS_PATH), toAddressPayload(draft))
      .pipe(unwrapEnvelope<unknown>(), map(readAddress), mapApiError());
  }

  override remove(id: string): Observable<void> {
    return this.http
      .delete<ApiEnvelope<void> | null>(apiPath(`${ADDRESS_PATH}/${encodeURIComponent(id)}`))
      .pipe(unwrapEnvelope<void>(), mapApiError());
  }
}

/** Мы только что отправили валидные поля: непригодный ответ — сбой сервера, а не пустой адрес в списке. */
function readAddress(raw: unknown): Address {
  const address = mapAddress(raw);
  if (address === null) {
    throw new ApiError(500, 'unknown');
  }
  return address;
}
